/*
 * @Author: wonderswang
 * @Date: 2023-4-26 15:18:25
 * @LastEditTime: 2023-4-26 15:18:31
 * @LastEditors: wonderswang wonderswang@tencent.com
 * @Description: 此文件renderer、main进程都加载，会在渲染进程加载前就初始化
 * @FilePath: /smh-drive-client/src/common/constant/index.ts
 */
import { IS_DEV, platform } from './platform';
export * from './platform';
export * from './protocol';

/** 主进程资源所在路径 */
export const RESOURCES_PATH = (function getResourcesPath() {
  if (IS_DEV) {
    return 'resources';
  }

  return process.resourcesPath;
})();

export const SENTRY_URL = (function getSentryURL() {
  const SENTRY_URL: Record<string, string> = {
    pc_test: 'https://77974c3f3539413caee6f82957e0ccf0@tamaegis.com/sentry/3844',
    browser_test: 'https://495ca9e2eba9417b9caf114cda96395d@tamaegis.com/sentry/3997',
    pc: 'https://8578424f0cc94bc3a82b69fe04f6892c@tamaegis.com/sentry/3917',
    browser: 'https://0acf22e6a396405cafcd855961fa5886@tamaegis.com/sentry/3827',
  };
  let type = platform === 'browser' ? 'browser' : 'pc';
  const isTest = !!process.env.VUE_APP_TEST_PUBLISH;
  const isPre = !!process.env.VUE_APP_PRE_PUBLISH;
  if (isTest || isPre || process.env.NODE_ENV === 'development') {
    type += '_test';
  }
  return SENTRY_URL[type];
})();

export enum Status {
  running = 'running',
  waiting = 'waiting',
  paused = 'paused',
  error = 'error',
  success = 'success',
  finish = 'finish',
  start = 'start',
  stop = 'stop',
  cancel = 'cancel',
}
// 速度单位
export const SPEED_UNIT = {
  mbs: 'MB/s',
  kbs: 'KB/s',
};

/**
 * @description 存储容量单位换算
 * @export
 * @enum {number}
 */
export enum StorageCapacityUnit {
  B = 1,
  KB = 1024,
  MB = 1024 * 1024,
  GB = 1024 * 1024 * 1024,
  TB = 1024 * 1024 * 1024 * 1024,
  PB = 1024 * 1024 * 1024 * 1024 * 1024,
  EB = 1024 * 1024 * 1024 * 1024 * 1024 * 1024,
}
